var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28.32V17.8302H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.93 -0.00012207H12.39V7.24329H0V10.5864H12.39V17.8298H15.93V10.5864H28.32V7.24329H15.93V-0.00012207Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7813 12.0156L28.32 15.4463V12.0156H21.7813ZM17.2383 12.0156L28.32 17.8297V16.1857L20.372 12.0156H17.2383ZM25.3682 17.8297L17.2383 13.5639V17.8297H25.3682Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2383 12.0156L28.32 17.8297V16.1857L20.372 12.0156H17.2383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2383 12.0156L28.32 17.8297V16.1857L20.372 12.0156H17.2383Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99699 12.0156L0 14.6374V12.0156H4.99699ZM11.0817 12.755V17.8298H1.40997L11.0817 12.755Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94802 12.0156L0 16.1857V17.8297L11.0817 12.0156H7.94802Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53877 5.814L0 2.38332V5.814H6.53877ZM11.0817 5.814L0 -0.00012207V1.64397L7.94802 5.814H11.0817ZM2.95181 -0.00012207L11.0817 4.26571V-0.00012207H2.95181Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0817 5.814L0 -0.00012207V1.64397L7.94802 5.814H11.0817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0817 5.814L0 -0.00012207V1.64397L7.94802 5.814H11.0817Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.323 5.81405L28.32 3.1923V5.81405H23.323ZM17.2383 5.07469V-0.00012207H26.9101L17.2383 5.07469Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.372 5.814L28.32 1.64397V-0.00012207L17.2383 5.814H20.372Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.32,
    height: 17.83,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/gb.1c367fbd52c4d1673afe8c7011338d9e.svg";
export { ForwardRef as ReactComponent };